import TabbedSections from "@/components/TabbedSections";
import { sectionsByGroup } from "@/config/sections";

// 시스템 오류(/system) — 기존 DevopsSection을 최상위 영역으로 승격 (2026-08-21 IA 재편).
// Admin에서 분리한 이유: 서비스 안정성 모니터링은 "운영 계정 관리"와 다른 업무 흐름.
// 향후 Lambda Timeout, API Gateway 5xx, DDB Throttling 등 확장 계획.
const TABS = sectionsByGroup("system");

export default function SystemPage() {
  return <TabbedSections tabs={TABS} hideTabs />;
}
